/*
 * Copyright (c) 2024 Omnissa, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Component, OnInit, NgZone } from '@angular/core';
import { Router,ActivatedRoute,Params } from '@angular/router';
import { AlertService } from '../services/alert.service';
import { ReportsService } from '../reports/reports.service';
import { VMwareProducts } from '../models/vmwareproducts';
import { ProductReleases } from '../models/productreleases';
import { Observable } from 'rxjs/Rx';
import { MaximumCategory } from '../models/maximumcategory';
import { MaximumSubCategory } from '../models/maximumsubcategory';
import { ElementData } from '../models/elementdata';
import { ConfigMaxSet } from '../models/configmaxset';
import { forEach } from '@angular/router/src/utils/collection';
import { AuthService } from '../auth/authservice.service';
import { Element } from '@angular/compiler';
import { CategoryDataRecord } from '../models/categorydatarecord';
import { CategoriesRecord } from '../models/categoriesrecord';
import { Subscription } from 'rxjs/Subscription';
import { NumberConstants } from "../common/numberconstants";
import { Globals } from 'app/common/globals';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentsService } from 'app/services/enviornment.service';

@Component({
    styleUrls: ['./reports.component.scss'],
    templateUrl: './reports.component.html',
    outputs: ['limitdata : category'],
})
export class ReportsComponent implements OnInit {
    collapsible: Boolean = true;
    collapsed: Boolean = false;
    isReportsMenu: Boolean = false;
    isReviewMenu: Boolean = false;
    isCompareMenu: Boolean = false;
    productsRight: VMwareProducts[];
    versionsRight: ProductReleases[];
    maximumssRight: any[];
    subcategoriesRight: any[];
    selectedProduct: number;
    selectedObject: VMwareProducts;
    selectedVersion: any;
    selectedCategory: any;
    selectedSubCategory: any;
    categoryupdated: boolean = false;
    subcategories: any;
    parentCat: any;
    subcategorySelected: any
    products: any;
    versions: any;
    maximums: any;
    prodData: ElementData;
    versionData: ElementData;
    versionMaxData: ElementData;
    cloneData: ElementData;
    clonedCategory: any;
    clonedsubcategory: any;
    currentVersionData: any;
    currentDate: ElementData;
    comment: ElementData;
    currentMaximumData: ElementData;
    targetVersionData: any;
    prodMgr: ElementData;
    addProjectData;
    createMaximumData;
    allselected = false;
    currentUser = JSON.parse(localStorage.getItem('currentUser'));
    showSpinner: boolean = false;
    showProducts:boolean = false;
    private subscription: Subscription;
    categoryUpdated:boolean=false;
    previousSelectedCategories:any;
    DEFAULT_SORT_TYPE:number = this.numberConstant.ZERO;
    prodIdx = this.numberConstant.ZERO;
    versionIdx = this.numberConstant.ZERO;
    langSub: Subscription;
    copyProddata: any;
    desc: any;
    categories: any;
    catsorData: any;
    Subategories: any;
    SubCatsorData: any;

    constructor(private zone: NgZone, private router: Router,
        private alertService: AlertService, private reportService: ReportsService,private globals: Globals,
        private authService: AuthService,private route: ActivatedRoute,private numberConstant:NumberConstants, private translateService: TranslateService,private envService: EnvironmentsService) {
        this.isReportsMenu = router.url.startsWith("/reports");
        this.isReviewMenu = router.url.startsWith("/review");
        this.isCompareMenu = router.url.startsWith("/repcomp");
        this.initializeTree();
        this.initializeVriables();

    }

    ngOnInit() {
        this.subscription = this.route.queryParams.subscribe((params: Params) => {
            if (params['vmwareproduct']) {
                this.reportService.selectedBookmarkedprod = params["vmwareproduct"];
                this.reportService.selectedBookmarkedversion = params["release"];
                this.reportService.selectedBookmarkedCategories = params["categories"];
                }
                else{
                    this.reportService.selectedBookmarkedprod = this.reportService.selectedprodName;
                    this.reportService.selectedBookmarkedversion = this.reportService.selectedverName;
                    this.reportService.selectedBookmarkedCategories = "";
                }
            });
        this.langSub = this.envService.selectedLanguage$.subscribe((lang)=>{
            this.versions[0].type = this.translateService.instant('selectVersion');
            this.products[0].type = this.translateService.instant('selectProduct');
            this.maximums[0].type = this.translateService.instant('allcategoriesLabel');
            this.copyProddata = this.translateService.instant('manLimits.editConfigBoxCloneFrom');
            this.translateService.instant('revertAlertLabel');
            this.prodMgr = this.translateService.instant('catFormModal.prodManager');
            this.desc = this.translateService.instant('viewLimits.description');
            this.categories = this.translateService.instant('categories');
            this.catsorData = this.translateService.instant('catFormModal.catSortOrder');
            this.Subategories = this.translateService.instant('catFormModal.subCategories');
            this.SubCatsorData = this.translateService.instant('catFormModal.subCategorySortOrder');
            this.createMaximumData.title = this.translateService.instant('reports.createCategoryLabel');
            this.createMaximumData.cancelButton = this.translateService.instant('cancel');
            this.createMaximumData.okButton = this.translateService.instant('create');
            this.addProjectData.title = this.translateService.instant('newMaximumSet');
            this.addProjectData.cancelButton = this.translateService.instant('cancel');
            this.addProjectData.okButton = this.translateService.instant('create');
            this.initializeLabels();
            this.initializeproductData([this.prodData, this.versionData, this.cloneData,
                this.copyProddata, this.currentVersionData, this.currentDate, this.comment]);
        });
        this.showProducts = this.showComponentsAuthorized("SHOW_PRODUCTS");
         if (this.isCompareMenu) {
             this.getProductInConfigSet();
         }
        this.subscription = this.reportService.notifyObservable$.subscribe((res) => {
            if (res.hasOwnProperty('option') && res.option === 'category') {
                this.previousSelectedCategories = this.reportService.selectedCategories
                this.getSelProductCategories(
                    this.reportService.selectedprodID,
                    this.reportService.selectedversionID
                );
                this.categoryUpdated = true;
            }
        });
    }

    initializeLabels(){
        this.copyProddata = ElementData.getproddata(this.translateService.instant('manLimits.editConfigBoxCloneFrom'), true,this.translateService.instant('enter'),this.translateService.instant('name'));
        this.prodData = ElementData.getproddata(this.translateService.instant('product'), false,this.translateService.instant('enter'),this.translateService.instant('name'));
        this.versionData = ElementData.getselecversiondata(this.translateService.instant('manLimits.version'), false,this.translateService.instant('enter'),this.translateService.instant('name'));
        this.cloneData = ElementData.getclonedata(this.translateService.instant('newStatus'),this.translateService.instant('create'),this.translateService.instant('clone'));
        this.currentVersionData = ElementData.getselecversiondata(this.translateService.instant('manLimits.editConfigBoxCloneVersion'), true,this.translateService.instant('enter'),this.translateService.instant('name'));
        this.currentDate = ElementData.getCurrentDate(this.translateService.instant('manageRelModal.publishDate'));
        this.comment = ElementData.getDescData(this.translateService.instant('limit.comment'));
    }

    assignArray(type: String, expanded: boolean, rights: any[]): any[] {
        let arr = [{
            type: type,
            expanded: expanded,
            rights: rights
        }];
        return arr;
    }

    getProductInConfigSet(): void {
        let  prods = null;
        if(!this.isCompareMenu) {
          this.setRoleId();
          prods = this.reportService.roleIds;
        }
        this.reportService.getProducts(prods).subscribe(
            vmwareproducts => {
                let filteredProductsRight: Array<any> = [];
                vmwareproducts.forEach(vmwareprod => {
                    if(vmwareprod.support === true) {
                        filteredProductsRight.push(vmwareprod);
                    }
                });
                this.productsRight = filteredProductsRight;
                // this.productsRight = vmwareproducts;
                if (this.productsRight != null && this.productsRight != undefined &&
                    this.productsRight.length > this.numberConstant.ZERO) {
                    this.products.rights = this.productsRight;
                    this.selectedProduct = this.productsRight[this.numberConstant.ZERO].id;
                    this.selectedObject = this.productsRight[this.numberConstant.ZERO];
                    this.reportService.selectedprodID = this.productsRight[this.numberConstant.ZERO].id;
                    this.reportService.selectedprodName = this.productsRight[this.numberConstant.ZERO].rmVmwProduct;
                    if(this.reportService.selectedBookmarkedprod.length >this.numberConstant.ZERO) {
                        for (let i = this.numberConstant.ZERO; i < this.productsRight.length; i++) {
                              if(this.productsRight[i].rmVmwProduct == this.reportService.selectedBookmarkedprod) {
                                  this.prodIdx = i;
                                  this.reportService.selectedprodID = this.productsRight[i].id;
                                  this.reportService.selectedprodName = this.productsRight[i].rmVmwProduct;
                                  this.selectedProduct = this.productsRight[i].id;
                                  this.reportService.selectedBookmarkedprod ="";
                                  break;
                              }
                        }

                    }
                    var vmwareProducts: VMwareProducts;
                    this.products = this.assignArray(
                        this.translateService.instant('selectProduct'),
                        true,
                        this.productsRight
                    );
                    this.reportService.selectedprodsInCfSet = vmwareproducts;
                    if (this.currentUser != null) {
                        this.getSelProductVersionsByID(this.numberConstant.HASCONFIGSET);
                    } else {
                        this.getSelProductVersionsByID(this.numberConstant.HASCONFIGSETANDPUBLISHED);
                    }
                }
            },
            err => {
                // Log errors if any
                console.log(err);
            }
        );
    }
    getProducts(): void {
        this.setRoleId();
        this.reportService.getReleases(this.reportService.roleIds)
            .subscribe(
                vmwareproducts => {
                    let products = vmwareproducts;
                    this.reportService.selectedprods = vmwareproducts;
                    this.selectedProduct = products[this.numberConstant.SELECTEDOBJECT].id;
                    this.getSelectedProductVersions();
                    let arr = this.getProductArray(products, true, false, this.numberConstant.ONE);
                    this.prodData = ElementData.getproddata(this.translateService.instant('product'), false,this.translateService.instant('enter'),this.translateService.instant('name'));
                    this.prodData.options = arr;
                    this.prodData.selectedValue = arr[this.numberConstant.SELECTEDOBJECT];
                    this.copyProddata = ElementData.getproddata(this.translateService.instant('manLimits.editConfigBoxCloneFrom'), true, this.translateService.instant('enter'),this.translateService.instant('name'));
                    this.cloneData = ElementData.getclonedata(this.translateService.instant('newStatus'),this.translateService.instant('create'),this.translateService.instant('clone'));
                    this.initializeproductData([this.prodData, this.versionData, this.cloneData,
                    this.copyProddata, this.currentVersionData, this.currentDate, this.comment]);
                    this.initializeMaximumdata(products);
                },
                err => {
                    // Log errors if any
                    console.log(err);
                })
    }

    getSelProductVersionsByID(val: number): void {
        this.reportService
            .getProductVersions(this.selectedProduct.toString(), val)
            .subscribe(
                vmwareproductsVersions => {
                    this.zone.run(() => {
                            // <== added
                        // Filter here
                        let filteredVersionsRight: Array<any> = [];
                        vmwareproductsVersions.forEach(vmwareversion => {
                            if(vmwareversion.support === true) {
                                filteredVersionsRight.push(vmwareversion);
                            }
                        });
                        this.versionsRight = filteredVersionsRight;
                        this.selectedVersion = this.versionsRight[this.numberConstant.ZERO];
                        this.selectedProduct = this.versionsRight[this.numberConstant.ZERO].id;
                        this.reportService.selectedversionID = this.selectedVersion.id;
                        this.versions = this.assignArray(
                            this.translateService.instant('selectVersion'),
                            true,
                            this.versionsRight
                        );
                        if(this.reportService.selectedBookmarkedversion.length > this.numberConstant.ZERO) {
                            for (let i = this.numberConstant.ZERO; i < this.versionsRight.length; i++) {
                                if(this.versionsRight[i].rmVmwPrdRelVersion == this.reportService.selectedBookmarkedversion) {
                                    this.versionIdx = i;
                                    this.selectedVersion = this.versionsRight[i];
                                    this.reportService.selectedversionID = this.versionsRight[i].id;
                                    this.reportService.selectedverName = this.versionsRight[i].rmVmwPrdRelVersion;
                                    this.reportService.selectedBookmarkedversion ="";;
                                    break;
                                }
                          }
                        }

                        this.reportService.notifyOther({
                            option: "title",
                            value: this.selectedVersion.rmVmwPrdRelVersion
                        });
                        this.getSelProductCategories(
                            this.reportService.selectedprodID,
                            this.reportService.selectedversionID
                        );
                        this.reportService.getSelectedConfigset();
                    });
                },
                err => {
                    // Log errors if any
                    console.log(err);
                    this.versions = this.assignArray(
                        "Select Version",
                        true,
                        []
                    );
                }
            );
    }

    getSelectedProductVersions(): void {
        this.reportService.getProductVersions(this.selectedProduct.toString(), this.numberConstant.ONE) // Get all product release versions of a given product
            .subscribe(vmwareproductsVersions => {
                this.zone.run(() => { // <== added
                    this.reportService.selectedversions = vmwareproductsVersions;
                });
            },
                err => {
                    // Log errors if any
                    console.log(err)
                });

    }
    getcloneProductVersionByID(): void {
        this.reportService.getProductVersions(this.selectedProduct.toString(),this.numberConstant.ONE) // Get all product release versions of a given product
            .subscribe(vmwareproductsVersions => {
                this.zone.run(() => { // <== added
                    this.reportService.selectedversions = vmwareproductsVersions;
                });
            },
                err => {
                    // Log errors if any
                    console.log(err)
                });

    }

    getSelProductCategories(prodid: number, verid: number): void {
        this.reportService.getMaximumCategoriesByProductIdAndVersionId(prodid, verid)
            .subscribe(vmwareproductsMaximums => {
                this.zone.run(() => { // <== added
                    this.maximumssRight = vmwareproductsMaximums;
                    if (this.maximumssRight != undefined && this.maximumssRight.length > 0) {
                        this.selectedCategory = this.maximumssRight[this.numberConstant.SELECTEDOBJECT];
                        this.reportService.selectedCategories = this.maximumssRight;
                        this.maximums = this.assignArray(this.translateService.instant('allcategoriesLabel'), true, this.maximumssRight);
                        if (this.categoryUpdated) {
                            this.categoryUpdated = false;
                            if (this.previousSelectedCategories != undefined &&
                                this.reportService.selectedCategories != undefined) {
                                this.previousSelectedCategories.forEach(element => {
                                    if (element.selected === true) {
                                        this.reportService.selectedCategories.forEach(setElement => {
                                            if (element.id === setElement.id) {
                                                setElement.selected = true;
                                            }
                                        });
                                    }
                                });
                            }
                        }
                        if (this.reportService.selectedBookmarkedCategories != null &&
                            this.reportService.selectedBookmarkedCategories.length > this.numberConstant.ZERO) {
                            this.reportService.setBookarkedCategoriesSelected(this.reportService.selectedCategories);
                        }
                    }
                });
            },
            err => {
                // Log errors if any
                this.maximums = this.assignArray(this.translateService.instant('allcategoriesLabel'), true, []);
                console.log(err)
            });

    }
    onProdChange(id) {
        let productFiltered = new VMwareProducts();
        this.productsRight.forEach(product => {
            if (product.id == id) {
                productFiltered = product;
            }
        });
        this.reportService.categoriesArray = [];
        this.selectedProduct = productFiltered.id;
        this.selectedObject = productFiltered;
        this.reportService.selectedprodID = productFiltered.id;
        this.reportService.selectedprodName = productFiltered.rmVmwProduct;
        if (this.currentUser != null) {
            this.getSelProductVersionsByID(this.numberConstant.HASCONFIGSET);
        } else {
            this.getSelProductVersionsByID(this.numberConstant.HASCONFIGSETANDPUBLISHED);
        }
        this.getSelectedProductVersions();
        this.getcloneProductVersionByID();
    }

    onVersionChange(vmwareversionId) {
        let vmwareversion = new ProductReleases();
        this.versionsRight.forEach(version => {
            if (version.id == vmwareversionId) {
                vmwareversion = version;
            }
        });
        this.reportService.categoriesArray = [];
        this.selectedProduct = vmwareversion.id;
        this.selectedVersion = vmwareversion;
        this.reportService.selectedverName = vmwareversion.rmVmwPrdRelVersion;
        this.reportService.selectedversionID = this.selectedVersion.id;
        this.getSelProductCategories(this.reportService.selectedprodID, this.reportService.selectedversionID);
        this.reportService.notifyOther({ option: 'title', value: this.selectedVersion.rmVmwPrdRelVersion });
        this.reportService.maximumsCats1Selected = [];
        this.reportService.maximumsSubCats1Selected = [];
        this.reportService.getSelectedConfigset();
    }

    updateReview() {
        this.reportService.categoriesArray = [];
        if (this.maximums != undefined && this.maximums[this.numberConstant.SELECTEDOBJECT] != undefined &&
            this.maximums[this.numberConstant.SELECTEDOBJECT].rights != undefined) {
            this.maximums[this.numberConstant.SELECTEDOBJECT].rights.forEach(element => {
                if (element.child === false || (element.subcategories  && Array.isArray(element.subcategories) && element.subcategories.length == 0)) {
                    this.reportService.addToCategories(element.id);
                    this.reportService.addCategatoryData(element.id);
                } else if (element.child === true || (element.subcategories != undefined && element.subcategories.length > this.numberConstant.ZERO)) {
                    this.reportService.addToCategories(element.id);
                    this.reportService.addSubcategoriesToRightPanel(element.subcategories, element.id);
                }
            });
        }
        this.reportService.notifyOther({ option: 'click', value: this.selectedVersion.rmVmwPrdRelVersion });
    }

    updateSelections() {
        this.reportService.categoriesArray = [];
        this.reportService.
            maximumsCats1Selected = [];
        this.reportService.
            maximumsSubCats1Selected = [];
        this.reportService.totalRecords = this.maximums[this.numberConstant.SELECTEDOBJECT].rights.length;
        this.maximums[this.numberConstant.SELECTEDOBJECT].rights.forEach(element => {
            if (element.selected === true) {
                if (element.child === false || (element.subcategories  && Array.isArray(element.subcategories) && element.subcategories.length == 0)) {
                    this.reportService.addToCategories(element.id);
                    this.reportService.addCategatoryData(element.id);
                } else if (element.child === true) {
                    this.reportService.addToCategories(element.id);
                    this.reportService.addSubcategoriesToRightPanel(element.subcategories, element.id);
                }
            } else {
                if (element.child === false) {
                    this.reportService.
                        maximumsCats1Selected = this.searchItemSelected(this.reportService.
                            maximumsCats1Selected, element.id);
                } else if (element.child === true) {
                    this.reportService.
                        maximumsCats1Selected = this.searchItemSelected(this.reportService.
                            maximumsCats1Selected, element.id);
                    element.subcategories.forEach(elementsub => {
                        if (elementsub.selected === false) {
                            this.reportService.maximumsSubCats1Selected = this.searchItemSelected(this.reportService.
                                maximumsSubCats1Selected, elementsub.id);
                        }
                        if (elementsub.selected === true) {
                            const found = this.reportService.maximumsSubCats1Selected.indexOf(elementsub.id);
                            if (found == this.numberConstant.MINUS_ONE) {
                                this.reportService.maximumsSubCats1Selected.push(elementsub.id);
                                let maxidsnodups = Array.from(new Set(this.reportService.maximumsSubCats1Selected));
                                this.reportService.maximumsSubCats1Selected = maxidsnodups;
                                this.reportService.addSubCateoryData(element.id, elementsub);
                            }
                            if (this.reportService.maximumsCats1Selected == null || this.reportService.maximumsCats1Selected.length == this.numberConstant.ZERO) {
                                this.reportService.maximumsCats1Selected.push(this.numberConstant.ZERO);
                            }
                        }
                    });
                }
            }
        });
        this.reportService.totalRecords = this.gettotalCounts();
        this.reportService.notifyOther({ option: 'click', value: this.selectedVersion.rmVmwPrdRelVersion });

    }

    gettotalCounts(): number {
        let count = this.numberConstant.ZERO;
        this.maximums[this.numberConstant.SELECTEDOBJECT].rights.forEach(element => {
            if (element.selected === true) {
                if (element.child === false) {
                    count = count + this.numberConstant.ONE;
                } else if (element.child === true) {
                    count = count + element.subcategories.length;
                }
            }
        });
        return count;
    }

    searchItemSelected(list: any, item): any {
        let maxidsnodups = Array.from(new Set(list));
        list = maxidsnodups;
        const index = list.indexOf(item);
        if (index >= this.numberConstant.ZERO) {
            list.splice(index, this.numberConstant.ONE);
        }
        return list;
    }
    formModalHandlerForConfigMax(btnOutput: boolean) {
        this.showSpinner = true;
        if (btnOutput) {
            let configmaxset: ConfigMaxSet = new ConfigMaxSet();
            configmaxset.title = this.addProjectData.elements[this.numberConstant.SELECTEDOBJECT].selectedValue.value;
            configmaxset.vmwProductId = this.addProjectData.elements[this.numberConstant.SELECTEDOBJECT].selectedValue.id;
            configmaxset.publishedDate = new Date(this.addProjectData.elements[this.numberConstant.CONFIGSET].selectedValue);
            configmaxset.comments = this.addProjectData.elements[this.numberConstant.COMMENTS].selectedValue;
            let isclonedata;
            configmaxset.vmwProductReleaseId = new Array();
            configmaxset.vmwProductReleaseId.push(this.addProjectData.elements[this.numberConstant.SELECTEDVERSION].selectedValue.id);
            //here if clone option is checked
            if (this.addProjectData.elements[this.numberConstant.CLONE].options[this.numberConstant.ZERO].isChecked === true) {
                configmaxset.newVersion = true;
                configmaxset.name = this.addProjectData.elements[this.numberConstant.SELECTEDVERSION].selectedValue.value;
                configmaxset.cloneProductId = this.numberConstant.ZERO;
                configmaxset.coneProductReleaseId = [];
            }
            //end of clone option
            else {
                configmaxset.newVersion = false;
                configmaxset.name = this.addProjectData.elements[this.numberConstant.SELECTEDVERSION].selectedValue.value;
                configmaxset.cloneProductId = this.addProjectData.elements[this.numberConstant.SELECTEDPRODUCT].selectedValue.id
                configmaxset.coneProductReleaseId = new Array();
                configmaxset.coneProductReleaseId.push(this.addProjectData.elements[this.numberConstant.CLONEVERSION].selectedValue.id);
            }
            configmaxset.lastUpdate = new Date();

            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            configmaxset.updatedBy = currentUser.userName;
            this.reportService.addConfigmaxset(configmaxset)
                .subscribe(response => {
                    this.showSpinner = false;
                    this.zone.run(() => { // <== added
                        if (response.status && response.status === "OK") {
                            this.alertService.success(this.addProjectData.title + " - ConfigMaxSet created Succesfully");
                            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                            this.getProductInConfigSet();
                        } else {
                            this.alertService.warn(this.addProjectData.title + " - ConfigMaxSet could not be created.");
                            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                        }
                    });
                },
                    err => {
                        this.showSpinner = false;
                        console.log(err)
                    });



        } else {
            this.showSpinner = false;
            this.alertService.warn(this.addProjectData.title + this.translateService.instant('revertAlertLabel'));
            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
        }
        this.initializeVriables();
    }

    formModalHandlerForMaximum(btnOutput: boolean) {
        if (btnOutput) {
            let clonestatus: boolean;
            clonestatus = false;
            let maximum: MaximumCategory = new MaximumCategory();
            maximum.cmVmwProductId = this.createMaximumData.elements[this.numberConstant.SELECTEDOBJECT].selectedValue.id;
            maximum.cmVmwProdRelId = this.createMaximumData.elements[this.numberConstant.SELECTEDVERSION].selectedValue.id
            maximum.accessType = "GLOBAL";
            maximum.lastUpdate = new Date();
            let user = JSON.parse(localStorage.getItem('currentUser'));
            maximum.updatedBy = user.userName;
            maximum.primaryAuthor = this.createMaximumData.elements[this.numberConstant.PRIMARYAUTHOR].selectedValue;
            maximum.secondaryAuthor = user.userName;
            maximum.prodManager = this.createMaximumData.elements[this.numberConstant.PRODMANAGER].selectedValue;
            maximum.description = this.createMaximumData.elements[this.numberConstant.DESCRIPTION].selectedValue;

            maximum.catSortType = this.createMaximumData.elements[this.numberConstant.CATEGORYSORTDATA].selectedValue.id;
            maximum.catSelectedSortNumber = this.createMaximumData.elements[this.numberConstant.CATEGORYSORTDATA].selectedValue.sort;
             maximum.catSortorder = this.numberConstant.ZERO;

            let isclonedata;
            //if clone is not checked
            if (this.createMaximumData.elements[this.numberConstant.CLONE].options[this.numberConstant.ZERO].isChecked === true) {
                let submax: String = this.createMaximumData.elements[this.numberConstant.SUBMAXIMUM].selectedValue;
                submax = submax.split(' ').join('')
                let categorySelected = this.createMaximumData.elements[this.numberConstant.MAXIMUMCATEGORY].selectedValue;
                if(categorySelected.length > this.numberConstant.ZERO)
                   maximum.category = this.createMaximumData.elements[this.numberConstant.MAXIMUMCATEGORY].selectedValue
                else {
                maximum.category = this.createMaximumData.elements[this.numberConstant.SELECTDMAXIMUMCATEGORY].selectedValue.value;
                if(maximum.catSortType === this.DEFAULT_SORT_TYPE)
                  maximum.catSortorder = this.createMaximumData.elements[this.numberConstant.SELECTDMAXIMUMCATEGORY].selectedValue.sortorder;
                }
                if (submax.length > this.numberConstant.ZERO) {
                    maximum.child = true;
                    //in case of add maximum withoutg clone
                    maximum.subCategory = this.createMaximumData.elements[this.numberConstant.SUBMAXIMUM].selectedValue;
                    maximum.subCatSortType = this.createMaximumData.elements[this.numberConstant.SUBCATEGORYSORTDATA].selectedValue.id;
                    maximum.subCatSelectedSortNumber = this.createMaximumData.elements[this.numberConstant.SUBCATEGORYSORTDATA].selectedValue.sort;
                    maximum.subCatSortorder = this.numberConstant.ZERO;

                } else {
                    maximum.child = false;
                }
            } else {
                clonestatus = true;
                maximum.clonecatId = this.createMaximumData.elements[this.numberConstant.CLONEVERSION].selectedValue.id;
                if (this.createMaximumData.elements[this.numberConstant.CLONEVERSION].selectedValue != undefined) {
                    maximum.child = true;
                    maximum.cloneSourceCatid = this.createMaximumData.elements[this.numberConstant.SOURCECATEGORY].selectedValue.id;
                    maximum.cloneTargetCatid = this.createMaximumData.elements[this.numberConstant.SELECTEDCATEGORY].selectedValue.id;
                    maximum.prodManager = this.createMaximumData.elements[this.numberConstant.PRIMARYAUTHOR].selectedValue;
                } else {
                    maximum.child = false;
                }
            }
            this.reportService.addMaximum(maximum, clonestatus)
                .subscribe(response => {
                    this.zone.run(() => { // <== added
                        if (response.status && response.status === "OK") {
                            this.alertService.success(this.createMaximumData.title + this.globals.categorySuccesslabel);
                            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                        } else {
                            this.alertService.warn(this.createMaximumData.title + this.globals.categoryDuplicatelabel);
                            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                        }
                    });
                },
                    err => {
                        console.log(err)
                    });
        } else {
            this.alertService.warn(this.addProjectData.title + this.translateService.instant('revertAlertLabel'));
            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
        }
          this.initializeVriables();
          this.getProductInConfigSet();
    }

    initializeTree() {
        this.products = [
            {
                type: "Select Product",
                expanded: true,
                rights: []
            }
        ];

        this.versions = [
            {
                type: "Select Version",
                expanded: true,
                rights: []
            }
        ];
        this.maximums = [
            {
                type: this.translateService.instant('allcategoriesLabel'),
                expanded: true,
                rights: []
            }
        ];
        this.currentVersionData = [
            {
                type: "Select Version",
                expanded: true,
                rights: []
            }
        ];
        this.clonedCategory = [
            {
                type: "All Category",
                expanded: true,
                rights: []
            }
        ];
        this.clonedsubcategory = [{
            type: "select sub Category",
            expanded: true,
            rights: []
        }];

    }
    initializeVriables() {
        this.initializeLabels();
        this.initializeproductData([this.prodData, this.versionData, this.cloneData,
        this.copyProddata, this.currentVersionData, this.currentDate, this.comment]);
        this.initializeMaximumdata([]);
        if (!this.showProducts && !this.isCompareMenu) {
            this.getProducts();
            this.getProductInConfigSet();
        }

    }
    initializeMaximumdata(arr: any) {
        let versionData = ElementData.getproddata(this.translateService.instant('manLimits.version'), false, this.translateService.instant('enter'),this.translateService.instant('name'));
        let cloneData = ElementData.getclonedata(this.translateService.instant('newStatus'),this.translateService.instant('create'),this.translateService.instant('clone'));
        let targetVersionData = ElementData.getselectTargetVersiondata(this.translateService.instant('cloneFromProd'), true,this.translateService.instant('enter'),this.translateService.instant('name'));
        let clonecatData = ElementData.getclonedataCategories(this.translateService.instant('cloneCategory'), true,this.translateService.instant('enter'),this.translateService.instant('name'));
        clonecatData.options = this.clonedCategory;
        let newMaxData = ElementData.getVersiondata(this.translateService.instant('newCategory'));
        let selectCategory = ElementData.getproddata(this.translateService.instant('existingCat'),false, this.translateService.instant('enter'),this.translateService.instant('name'));
        let newMaxsubData = ElementData.getVersiondata(this.translateService.instant('newSubCat'));
        this.currentMaximumData = ElementData.getproddata("Current Category", false,this.translateService.instant('enter'),this.translateService.instant('name'));

        this.prodMgr = ElementData.getVersiondata(this.translateService.instant('manLimits.prodManager'));
        this.desc = ElementData.getDescData(this.translateService.instant('viewLimits.description'));
        let sortoptions: any = this.setSortOptions(true);
        this.categories = ElementData.getSortdata(this.translateService.instant('categories'), false);
        this.catsorData = ElementData.getselectSortValue(this.translateService.instant('catFormModal.catSortOrder'), false);
        this.catsorData.options = sortoptions
        this.catsorData.selectedValue = sortoptions[this.numberConstant.ZERO];
        this.Subategories = ElementData.getSortdata(this.translateService.instant('catFormModal.subCategories'), false);
        this.SubCatsorData = ElementData.getselectSortValue(this.translateService.instant('catFormModal.subCategorySortOrder'), false);
        let subcategorysortoptions: any = this.setSortOptions(false);
        this.SubCatsorData.options = subcategorysortoptions;
        this.SubCatsorData.selectedValue = subcategorysortoptions[this.numberConstant.ZERO];
        let maxarr = [this.prodData, versionData, cloneData, targetVersionData,
            clonecatData, newMaxData, selectCategory, this.catsorData, this.categories, newMaxsubData, this.SubCatsorData, this.Subategories, this.prodMgr, this.desc];
        this.createMaximumData = {
            state: false,
            backdrop: true,
            title: this.translateService.instant('reports.createCategoryLabel'),
            subTitle: " ",
            cancelButton: this.translateService.instant('cancel'),
            okButton: this.translateService.instant('create'),
            cancelBClass: "btn-outline",
            okBClass: "btn-primary",
            elements: maxarr,
            isMaximum: true,
        }
    }
    getProductArray(array: any, prod, copy, cat): any {
        let arr: any = new Array();
        arr.push({ id: this.numberConstant.ZERO, value: this.translateService.instant('select'), cat: cat, isprod: prod, iscopy: copy });
        if (array != null && array != undefined) {
            array.forEach(element => {
                arr.push({ id: element.id, value: element.rmVmwProduct, cat: cat, isprod: prod, iscopy: copy });
            });
        }
        return arr;
    }
    getCategoryArray(array: any, prod, copy, cat): any {
        let arr: any = new Array();
        arr.push({ id: this.numberConstant.ZERO, value: this.translateService.instant('select'), cat: cat, isprod: prod, iscopy: copy });
        if (array != null && array != undefined) {
            array.forEach(element => {
                arr.push({ id: element.id, value: element.category, cat: cat, isprod: prod, iscopy: copy });
            });
        }
        return arr;
    }
    initializeproductData(elementsarr: any) {
        this.addProjectData = {
            state: false,
            backdrop: true,
            title: this.translateService.instant('newMaximumSet'),
            subTitle: "",
            cancelButton: this.translateService.instant('cancel'),
            okButton: this.translateService.instant('create'),
            cancelBClass: "btn-outline",
            okBClass: "btn-success",
            elements: elementsarr,
            isMaximum: false
        };
    }

    showComponentsAuthorized(resourceName): boolean {
        let hideComponent = true;
        if (this.reportService.resorceactions === undefined ||
            this.reportService.resorceactions.length === this.numberConstant.ZERO) {
            return true;
        }
        return hideComponent = this.authService.checkaction(resourceName);
    }
    selectAllCategories(elementEvent) {
        this.allselected = true;
        let eleState = elementEvent.target.checked;
        for (let i = this.numberConstant.ZERO; i < this.maximums[this.numberConstant.ZERO].rights.length; i++) {
            this.maximums[this.numberConstant.ZERO].rights[i].selected = eleState;
        }
    }

    updateAllCatSelection() {
        let atleastOnceUncheck = false;
        for (let i = this.numberConstant.ZERO; i < this.maximums[this.numberConstant.ZERO].rights.length; i++) {
            if (!this.maximums[this.numberConstant.ZERO].rights[i].selected) {
                atleastOnceUncheck = true;
                break;
            }
        }
        if (atleastOnceUncheck == false) {
            this.allselected = true;
        }
        else {
            this.allselected = false;
        }
    }

    loadData(): Boolean {
        if (!this.showProducts) {
            return true;
        } else if (!this.isCompareMenu) {
                this.router.navigate(['/home']);
        } else {
            return true;
        }
    }

    setRoleId(): void {
        let token: string = localStorage.getItem('token');
        if (token != null) {
            let decodeTokenString = this.authService.decodeTokenStr(token);
            if (null != decodeTokenString)
                this.reportService.roleIds = decodeTokenString["rid"];
        }
    }

    setSortOptions(isCat:boolean):any {
        let sortoptions = new Array();
        sortoptions.push({ id: this.numberConstant.ZERO, value: this.translateService.instant('default'), isCat: isCat,sort:this.numberConstant.ZERO});
        sortoptions.push({ id: this.numberConstant.TWO, value: this.translateService.instant('before'), isCat: isCat,sort:this.numberConstant.ZERO});
        sortoptions.push({ id: this.numberConstant.ONE, value: this.translateService.instant('after'), isCat: isCat,sort:this.numberConstant.ZERO});
        return sortoptions;
    }

        ngOnDestroy(){
        this.langSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/reports/reports.component.ts